import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Component, computed, ref, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { toast } from "@/common/utils/toast";
import store from "@/store";

import { DesktopCockpitTheme, MobileCockpitTheme } from ".";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

import { evaluationShow } from "@/common/api/rest/evaluation/evaluation";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'cockpit',
  props: {
    accountId: {},
    evaluationId: {},
    evaluations: {},
    tabList: {},
    menuList: {},
    isEdit: { type: Boolean }
  },
  emits: [
  "update-data",
  "add",
  "input-search",
  "search",
  "change-status",
],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const evaluation = ref<EvaluationType | null>(null);

const listMenu = computed(() =>
  props.menuList.reduce((acc, item) => {
    const modules = store.getters.modules;

    if (
      item.key === "method" &&
      modules.find((mod) => mod.code === "METHOD_NOT")
    ) {
      console.log("modules", modules);
      return acc;
    } else {
      acc.push(item);
    }

    return acc;
  }, []),
);

function fetchData() {
  if (!props.evaluationId) return;

  evaluationShow(props.accountId, props.evaluationId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        evaluation.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
  fetchData();
}

watch(
  () => [props.evaluationId],
  () => fetchData(),
  { immediate: true, deep: true },
);

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (!_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(DesktopCockpitTheme), {
        key: 0,
        "is-edit": props.isEdit,
        "account-id": props.accountId,
        "evaluation-id": props.evaluationId || null,
        evaluations: props.evaluations,
        evaluation: evaluation.value,
        "tab-list": props.tabList,
        "menu-list": listMenu.value,
        onUpdateData: _cache[0] || (_cache[0] = ($event: any) => (update())),
        onAdd: _cache[1] || (_cache[1] = ($event: any) => (emit('add'))),
        onInputSearch: _cache[2] || (_cache[2] = ($event: any) => (emit('input-search', $event))),
        onSearch: _cache[3] || (_cache[3] = ($event: any) => (emit('search', $event))),
        onChangeStatus: _cache[4] || (_cache[4] = ($event: any) => (emit('change-status', $event)))
      }, null, 8, ["is-edit", "account-id", "evaluation-id", "evaluations", "evaluation", "tab-list", "menu-list"]))
    : (_openBlock(), _createBlock(_unref(MobileCockpitTheme), {
        key: 1,
        "is-edit": __props.isEdit,
        "account-id": props.accountId,
        "evaluation-id": props.evaluationId || null,
        evaluations: props.evaluations,
        evaluation: evaluation.value,
        "tab-list": props.tabList,
        "menu-list": listMenu.value,
        onUpdateData: _cache[5] || (_cache[5] = ($event: any) => (update())),
        onAdd: _cache[6] || (_cache[6] = ($event: any) => (emit('add'))),
        onInputSearch: _cache[7] || (_cache[7] = ($event: any) => (emit('input-search', $event))),
        onSearch: _cache[8] || (_cache[8] = ($event: any) => (emit('search', $event)))
      }, null, 8, ["is-edit", "account-id", "evaluation-id", "evaluations", "evaluation", "tab-list", "menu-list"]))
}
}

})